import { getPublicConfig } from "common/config/publicConfig";
import { initGoogleMaps } from "common/config/initGoogleMaps";
import { initDataGrail } from "common/config/initDataGrail";
import { initHeap } from "common/config/initHeap";

export function initThirdPartyScripts(): void {
  const {
    googleMapsBrowserApiKey,
    dataGrailCustomerId,
    dataGrailContainerId,
    heapId,
    heapDataConsentId,
  } = getPublicConfig();
  initGoogleMaps(googleMapsBrowserApiKey);
  initDataGrail(dataGrailCustomerId, dataGrailContainerId);
  initHeap(heapId, heapDataConsentId);
}
